<template>
	<div>
		<p class="mb-0"><strong>Rate: </strong> #{{ offer.id }}</p>
		<p class="mb-0"><strong>Carrier: </strong> {{ offer.carrier.data.business.data.name }} (#{{ offer.carrier.data.id }})</p>
	</div>
</template>

<script>
    export default {
        name: 'admin-delivery-date-info',
		props: ['offer'],
		methods: {
			moment: function (...args) {
				return moment(...args);
			}
		}
    }
</script>